var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.167,
    height: 37.285,
    viewBox: "0 0 64.167 37.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8237",
    "data-name": "Group 8237",
    transform: "translate(-2658.824 -1901.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8236",
    "data-name": "Group 8236",
    transform: "translate(2659.338 1901.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8235",
    "data-name": "Group 8235",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16833",
    "data-name": "Path 16833",
    d: "M2692.343,1996.495c0,.212.01.424,0,.635a.975.975,0,0,1-1.912.223c-.093-.438-.1-.894-.154-1.34a9.806,9.806,0,0,0-17.168-5.231c-.257.281-.28.461.007.762a7.967,7.967,0,0,1-8.378,13.032,7.972,7.972,0,1,1,6-14.75c.292.131.458.136.674-.131a11.532,11.532,0,0,1,5.979-3.923,11.415,11.415,0,0,1,4.9-.29,11.6,11.6,0,0,1,8.535,5.829A10.65,10.65,0,0,1,2692.343,1996.495Zm-25,6.487a5.955,5.955,0,1,0-5.943-5.933A5.949,5.949,0,0,0,2667.345,2002.981Z",
    transform: "translate(-2659.338 -1968.851)",
    fill: "#3067ae",
    stroke: "#3067ae",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16834",
    "data-name": "Path 16834",
    d: "M2730.031,1909.2a7.218,7.218,0,0,1,7.219-7.261,7.251,7.251,0,1,1-.032,14.5A7.2,7.2,0,0,1,2730.031,1909.2Zm7.227,5.2a5.15,5.15,0,0,0,5.231-5.191,5.226,5.226,0,1,0-5.231,5.191Z",
    transform: "translate(-2716.056 -1901.936)",
    fill: "#3067ae",
    stroke: "#3067ae",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16835",
    "data-name": "Path 16835",
    d: "M2896.847,1909.3a7.249,7.249,0,1,1-7.244-7.3A7.212,7.212,0,0,1,2896.847,1909.3Zm-7.269,5.146a5.206,5.206,0,1,0-5.212-5.206A5.165,5.165,0,0,0,2889.578,1914.441Z",
    transform: "translate(-2838.262 -1901.984)",
    fill: "#3067ae",
    stroke: "#3067ae",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16836",
    "data-name": "Path 16836",
    d: "M2870.554,1985.143c4.626.177,7.962,1.911,10.3,5.418a11.241,11.241,0,0,1,1.919,6.087c.017.74-.36,1.22-.968,1.254s-1.05-.45-1.077-1.21a9.483,9.483,0,0,0-3.435-7.14,9.249,9.249,0,0,0-7.43-2.259,9.754,9.754,0,0,0-8.7,9.288,2.433,2.433,0,0,1-.166.819.96.96,0,0,1-1.081.472,1.055,1.055,0,0,1-.794-1.072,11.776,11.776,0,0,1,3.4-8.068,11.157,11.157,0,0,1,5.214-3.092C2868.79,1985.364,2869.889,1985.256,2870.554,1985.143Z",
    transform: "translate(-2819.628 -1968.694)",
    fill: "#3067ae",
    stroke: "#3067ae",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16837",
    "data-name": "Path 16837",
    d: "M2808.465,1941.648h.641q4.234,0,8.466,0c.76,0,1.2.413,1.177,1.075a1.037,1.037,0,0,1-1.166.968c-1.467.009-2.935,0-4.4,0h-4.724c.345.354.593.614.847.869,1.006,1.008,2.019,2.01,3.02,3.025a1.016,1.016,0,0,1,.247,1.3,1,1,0,0,1-1.653.15q-2.1-2.085-4.191-4.184c-.449-.449-.9-.892-1.341-1.351a1.043,1.043,0,0,1-.007-1.664q2.758-2.777,5.533-5.535a1.016,1.016,0,1,1,1.421,1.44c-1.149,1.166-2.311,2.318-3.467,3.476C2808.759,1941.331,2808.658,1941.443,2808.465,1941.648Z",
    transform: "translate(-2776.178 -1929.214)",
    fill: "#3067ae",
    stroke: "#3067ae",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_16838",
    "data-name": "Path 16838",
    d: "M2681.459,2027.629l-2.789,2.789-1.084-1.084-.853.853,1.937,1.937,3.642-3.641Z",
    transform: "translate(-12.136 -99.378)",
    fill: "#3067ae",
    stroke: "#3067ae",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefer);
export default __webpack_public_path__ + "static/media/Refer.a5ee242575622e214ade90afd3ec11a9.svg";
export { ForwardRef as ReactComponent };